import { useEffect, useRef, useState } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import { Table, Breadcrumb, Empty, Spin } from "antd"

import { getData, getDataDetail } from "@/apis/instance";
import { RightOutlined } from "@ant-design/icons";

export const InstanceDataPanel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFS, setIsLoadingFS] = useState(false);
  const [isLoadingDB, setIsLoadingDB] = useState(false);
  const [fsData, setFSData] = useState([]);
  const [dbData, setDBData] = useState([]);
  const [rootFSData, setRootFSData] = useState([]);
  const [rootDBData, setRootDBData] = useState([]);
  const initFSItem = [{title:(<div><RightOutlined /> HDFS</div>), key:"/"}];
  const fSItemsRef = useRef(initFSItem.concat());
  const [fsItems, setFSItems] = useState(initFSItem.concat());
  const initDBItem = [{title:(<div><RightOutlined /> MySQL</div>), key:"/"}];
  const [dbItems, setDBItems] = useState(initDBItem);
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedInstance] } = state;
  const id = selectedInstance?.id;
  const fsColumns = [
    {
      title: 'Folder',
      dataIndex: 'name',
      key: 'name',
      render: (value, record) => record.type == "folder"? (<a onClick={(e) => drillInFS(value, e)}>{value}</a>):(<li>{value}</li>)
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size'
    }
  ];
  const dbColumns = [
    {
      title: 'Database',
      dataIndex: 'name',
      key: 'name',
      render: (value, record) => record.type == "database"? (<a onClick={(e) => drillInDB(value, e)}>{value}</a>):(<li>{value}</li>)
    }, 
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size'
    } 
  ];
  const tableColumns = [
    {
      title: 'Table',
      dataIndex: 'table',
      key: 'table',
    }, 
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size'
    } 
  ];

  const drillInDB = (name, e) => {
    e.preventDefault();
    setDBItems([{title:(<a onClick={() => backToDB()}><RightOutlined /> MySQL</a>), key:"/"}, {title:name}]);
    getDetail("mysql", name);
  };

  const backToDB = () => {
    setDBItems(initDBItem.concat());
    setDBData(rootDBData);
  };
  const drillInFS = (name, e) => {
    e.preventDefault();
    let items = [];
    if(fSItemsRef.current.length > 1){
        let last = fSItemsRef.current.pop();
        let lname = last.title;
        last.title = (<a onClick={() => backToFS(last.key)}>{lname}</a>);
        items.push(last);
    } else if(fSItemsRef.current.length == 1){
        let last = fSItemsRef.current.pop();
        last.title = (<a onClick={() => backToFS("/")}><RightOutlined /> HDFS</a>);
        items.push(last);
    }
    let i = name.lastIndexOf("/") + 1;
    items.push({title:name.substring(i), key:name});
    fSItemsRef.current = fSItemsRef.current.concat(items);
    setFSItems(fSItemsRef.current);
    getDetail("hdfs", name);
  };

  const getDetail = async (type, path) =>{
    type == "hdfs"?setIsLoadingFS(true):setIsLoadingDB(true);
    const response = await getDataDetail(id, type, path);
    type == "hdfs"?setIsLoadingFS(false):setIsLoadingDB(false);
    if (response.status === "OK") {
      type == "hdfs"?setFSData(response.value || []):setDBData(response.value || []);
    } else {
      type == "hdfs"?setFSData([]):setDBData([]);
    }
  };

  const backToFS = (path) => {
    let idx = fSItemsRef.current.findIndex((item) => item.key == path);
    let items = fSItemsRef.current.slice(0, idx + 1);

    let last = items[idx];   
    if(idx > 0){
      let i = path.lastIndexOf("/") + 1;
      last.title = path.substring(i);
      getDetail("hdfs", path);
    } else {
      last.title = (<div><RightOutlined /> HDFS</div>);
      setFSData(rootFSData);
    }
    //getDetail("hdfs", path);
    fSItemsRef.current = items;
    setFSItems(items);
  };
  
  useEffect(() => {    
    setFSItems(initFSItem.concat());
    setDBItems(initDBItem.concat());
    getSummary(id);
  }, [id]);

  const getSummary = async ( id) => {
    setIsLoading(true);
    const response = await getData(id);
    setIsLoading(false);
    if (response.status === "OK") {
      let hfdsData = response.value?.hdfs || [];
      let dbData = response.value?.mysql || [];
      setFSData(hfdsData);
      setRootFSData(hfdsData);
      setDBData(dbData);
      setRootDBData(dbData);
    } else {
      setFSData([]);
      setRootFSData([]);
      setDBData([]);
      setRootDBData([]);
    }
  };
 /* const getSummary = async ( id, type="all" ) => {
      if(type == "all"){
        setIsLoading(true);
      } else if(type == "hdfs"){
        setIsLoadingFS(true);
      } else {
        setIsLoadingDB(true);
      }
      const response = await getData(id);
      if(type == "all"){
        setIsLoading(false);
      } else if(type == "hdfs"){
        setIsLoadingFS(false);
      } else {
        setIsLoadingDB(false);
      }
      if (response.status === "OK") {
        if(type == "hdfs"){
          setFSData(response.value?.hdfs || []);
        } else if(type == "mysql"){
          setDBData(response.value?.mysql || []);
        } else {
          setFSData(response.value?.hdfs || []);
          setDBData(response.value?.mysql || []);
        }
      } else {
        if(type == "hdfs"){
          setFSData([]);
        } else if(type == "mysql"){
          setDBData([]);
        } else {
          setFSData([]);
          setDBData([]);
        }
      }
      
  };*/
  
  return (
    <div>
      {(!selectedInstance || !isLoading && fsData.length < 1 && dbData.length < 1) && <Empty description={false} /> }
      { isLoading && <Spin size="large" /> }
      {!isLoading && selectedInstance && fsData.length > 0 && <Spin spinning={isLoadingFS} delay={500}><Breadcrumb items={fsItems} separator="/"/> 
        <Table size="small" dataSource={fsData} columns= {fsColumns}/></Spin>}
      {!isLoading && selectedInstance && dbData.length > 0 && <Spin spinning={isLoadingDB} delay={500}> <Breadcrumb items={dbItems} separator="/"/>
      {(dbItems.length == 1 || isLoadingDB)?<Table size="small" dataSource={dbData} columns= {dbColumns}/>:<Table size="small" dataSource={dbData} columns= {tableColumns}/>} </Spin>}
    </div>
  );
}; 
